import axios, { CancelTokenSource } from 'axios';
import { useEffect, useRef } from 'react';

export const getCancelSource = () => axios.CancelToken.source();

export const isRequestCancelled = (e: unknown) => axios.isCancel(e);

export const useCancelToken = () => {
  const source = useRef<CancelTokenSource | null>(null);

  /* Cancel request on navigation */
  useEffect(() => () => {
    window.onbeforeunload = () => {
      if (source.current) {
        source.current.cancel();
      }
    };

    if (source.current) {
      source.current.cancel();
    }
  }, []);

  const setCancellationToken = (cancellationSource: CancelTokenSource | null) => {
    source.current = cancellationSource;
  };

  const generateCancellationToken = () => {
    source.current = getCancelSource();

    return source.current;
  };

  return { cancelToken: source.current, generateCancellationToken, setCancellationToken };
};
